import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { NotificationType } from '../../app/models/notification-types.const';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomSnackbarComponent } from 'app/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translate = inject(TranslateService);
  private readonly sanitizer = inject(DomSanitizer);

  notify(notificationType: NotificationType, duration = 7000, params = ''): void {
    void this.openNotification(notificationType, duration, params);
  }

  private async openNotification(notificationType: NotificationType, duration: number, params: string): Promise<void> {
    const translations = await firstValueFrom(this.translate.get([notificationType, 'ok'], { params }));
    const translatedMessage = translations[notificationType];
    const actionLabel = translations['ok'];

    if (!this.isHtmlText(translatedMessage)) {
      this.snackBar.open(translatedMessage, actionLabel, { duration });

      return;
    }

    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message: this.sanitizer.bypassSecurityTrustHtml(translatedMessage) },
      duration,
    });
  }

  private isHtmlText(text: string): boolean {
    const htmlRegex = /<\/?[a-z][\s\S]*>/i;

    return htmlRegex.test(text);
  }
}
